import Image from "@editorjs/image";

class CustomImage extends Image {
  constructor({ data, config, api, readOnly }) {
    super({ data, config, api, readOnly });
  }
  static get toolbox() {
    return {}
  }
}

export default CustomImage;
